/* Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. */

import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'tableFilter',
  standalone: false,
})
export class TableFilterPipe<T> implements PipeTransform {
  filterColumns: string[] = [];
  newSearchTerm = '';
  filteredItems: T[] = [];

  transform(
    items: T[],
    searchTerm: string | number,
    filterColumns: string[],
    minChar: number | string,
    tableFilterMetadata?: { count: number },
  ): T[] {
    this.filterColumns = filterColumns;
    // make sure that minChar is a number and if not set it to 3
    minChar = !isNaN(parseInt(minChar.toString()))
      ? parseInt(minChar.toString())
      : 3;
    if (tableFilterMetadata) {
      tableFilterMetadata.count = items.length;
    }

    // make sure items is an object, the search term is longer than minChar and that filterColumns is an array and not empty before filtering, else return items unfiltered
    if (
      Object.prototype.toString.call(items) !== '[object Object]' &&
      searchTerm.toString().length >= minChar &&
      Array.isArray(filterColumns) &&
      filterColumns.length > 0
    ) {
      // if the searchTeam is a number convert it to a string and convert any strings to lowercase
      this.newSearchTerm = !isNaN(Number(searchTerm))
        ? searchTerm.toString()
        : searchTerm.toString().toLowerCase();
      this.filteredItems = items.filter((item) => {
        return this.flattenNestedObjects(item);
      });
      if (tableFilterMetadata) {
        tableFilterMetadata.count = this.filteredItems.length;
      }
      return this.filteredItems as T[];
    } else {
      return items;
    }
  }

  flattenNestedObjects(item: T): boolean {
    const flattenedObj: T = { ...item },
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      that = this;
    parseNestedObject(item);

    function parseNestedObject(item: T) {
      // iterate over object looking for nested objects
      for (const key in item) {
        const value = item[key];
        // check to make sure the item is actually an object
        if (Object.prototype.toString.call(value) === '[object Object]') {
          if (flattenedObj[key]) {
            // remove the found property from flattenedObj
            delete flattenedObj[key];
          }
          // pass the found property value back to parseNestedObject to check that it isn't an object itself
          parseNestedObject(value as T);
        } else {
          if (flattenedObj[key]) {
            // remove the found property from flattenedObj
            delete flattenedObj[key];
          }
          // add the found property value to root of the flattenedObj
          flattenedObj[key] = value;
        }
      }
    }
    // return the search results
    return that.generateSearchObject(item, flattenedObj);
  }
  generateSearchObject(item: T, flattenedObj: T): boolean {
    let prop = '';
    for (const key in flattenedObj) {
      // only search columns that are in the filterColumns array
      if (this.filterColumns.includes(key)) {
        // deal with null values
        const value = flattenedObj[key] != null ? flattenedObj[key] : '';
        prop =
          typeof value === 'number'
            ? value.toString()
            : value.toString().toLowerCase();
        if (prop.indexOf(this.newSearchTerm) > -1) {
          return true;
        }
      }
    }
    return false;
  }
}
